<template>
	<div class="animate__animated animate__fadeIn">
		<h4 class="font-weight-bold">Pendências e Ocorrências</h4>
		<div class="row">
			<div class="col-md-12">
				<table class="table table-bordered">
					<tbody>
						<tr v-for="item in $root.arrays.pendencias_familia" :key="item.id">
							<td :class="checkPendencias(item.id) ? 'bg-danger' : ''">
								<i :class="checkPendencias(item.id) ? 'mdi mdi-close' : ''"></i>
								{{ item.value }}
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	props: ["item"],
	data() {
		return {};
	},
	methods: {
		checkPendencias(pendencia) {
			if (this.item.pendencias) {
				return this.item.pendencias[pendencia] ? true : false;
			} else {
				return false;
			}
		},
	},
};
</script>
<style lang="css">
.bg-danger {
	background: #fb8994 !important;
	color: #424242 !important;
}
</style>


